import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const ReadNotificationIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M2 6.66008C2 8.7032 2 11.8918 2 11.8918C2 12.6865 2.67157 13.3307 3.5 13.3307H12.5C13.3284 13.3307 14 12.6865 14 11.8918V6.32237M2 6.66008C2 6.41202 2.13321 6.18146 2.3525 6.04999L8 2.66406L13.6177 5.69531C13.8539 5.82274 14 6.06245 14 6.32237M2 6.66008C2.3 6.66008 8 10.2183 8 10.2183L14 6.32237"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

ReadNotificationIcon.displayName = 'ReadNotificationIcon';
